<template>
  <section class="page-nurse-form">
    <breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-nurse-form
        @submit="updateUser"
        :genders="genders"
        :statuses="statuses"
        :roles="roles"
        v-model="form"/>

      <terms />
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import NurseForm from 'raypro_ui/src/components/ui/forms/Nurse'
  import {updateUser, getAvailableRoles, getUser, deactivateUser, activateUser} from 'raypro_ui/src/api/users'
  import Terms from '@/components/Terms'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'

  export default {
    data() {
      return {
        errors: {},
        form: {},
        roles: [],
        genders: [
          {'label': 'Male', 'value': 'M'},
          {'label': 'Female', 'value': 'F'},
          {'label': 'Prefer not to say', 'value': 'O'}
        ],
        status: '',
        statuses: [
          {label: 'Active', 'value': 'active'},
          {label: 'Inactive', 'value': 'inactive'}
        ],
        active: false,
        successMessage: 'Nurse updated successfully!',
        title: 'Edit Nurse',
        breadcrumbs: [
          {
            label: 'Nurses',
            link: 'all-users'
          },
          {label: 'Edit Nurse'}
        ]
      }
    },

    mixins: [page],

    mounted() {
      this.getRoles()
      this.getUser()
    },

    computed: {
      nursePayload() {
        const form = this.form

        return {
          user: {
            email: form.email,
            user_roles: [{role_id: form.role}],
            status: form.status,
            profile: {
              first_name: form.first_name,
              last_name: form.last_name,
              gender: form.gender,
            }
          }
        }
      }
    },

    props: {id: String},

    components: {
      'rp-nurse-form': NurseForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Breadcrumbs,
      Terms
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'all-users', params: {role: 'nurse'}})
      },

      getRoles() {
        getAvailableRoles().then(({data}) => {
          this.roles = data.available_roles.map((role) => {
            return {key: role.name, value: role.id}
          })
        })
      },

      getUser() {
        getUser(this.id).then(({data}) => {
          this.status = data.activated_at ? 'active' : 'inactive'

          this.form = {
            email: data.email,
            role: data.roles[0].id,
            first_name: data.profile.first_name,
            last_name: data.profile.last_name,
            salutation: data.profile.salutation,
            speciality: data.profile.speciality,
            gender: data.profile.gender,
            dob: data.profile.dob,
            status: data.activated_at ? 'active' : 'inactive'
          }
        })
      },

      updateUser() {
        const formStatus = this.nursePayload.user.status

        if(formStatus === 'active') {
          activateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        } else {
          deactivateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        }

        updateUser(this.id, this.nursePayload)
          .then(() => {
            this.active = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    }
  }
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/Nurses/EditNurse.vue